import React, { useState } from 'react'
import './App.less'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import SlerpClient from '@slerp/client'
import Login from 'components/Login'
import ForgotPasswordForm from 'components/Login/ForgotPasswordForm'
import ResetPasswordForm from 'components/Login/ResetPasswordForm'
import {
  SessionContext,
  authenticate,
  createSession,
  requestPasswordChange,
  resetPassword,
  signOut
} from '@slerp/accounts'
import {
  initializeGA4,
  initializeLinkedInInsights,
  initializePixel
} from './packages/@slerp/tracker'
import OnboardingForm from 'components/Login/OnboardingForm'
import { GlobalQueryProvider } from 'hooks/useGlobalQuery'
import { initSentry } from 'reporting/sentry'
import { DevInfoBanner } from 'components/DevInfoBanner'
import AppRouter from 'router/Router'
import SignIn from 'components/SingleSignOn/SignIn'
import GlobalContext from 'hooks/useGlobalContext/useGlobalContext'
import HubspotChat from 'components/HubspotChat'

function App() {
  initializeGA4()
  initializePixel()
  initializeLinkedInInsights()
  const isValidJson = (string?: string | null) => {
    try {
      string && JSON.parse(string)
    } catch (e) {
      return false
    }
    return true
  }

  const [user] = useState(
    isValidJson(localStorage.getItem('user'))
      ? JSON.parse(localStorage.getItem('user')!)
      : undefined
  )

  const [merchant] = useState(
    isValidJson(localStorage.getItem('merchant'))
      ? JSON.parse(localStorage.getItem('merchant')!)
      : undefined
  )

  const [token] = useState(localStorage.getItem('token') || '')

  // Sign out user if it's using the old token.
  if (token && token.length <= 36) signOut()

  const initialSessionState = {
    user,
    merchant,
    createSession,
    authenticate,
    requestPasswordChange,
    resetPassword,
    token
  }

  initSentry({
    environment: process.env.REACT_APP_TEST_ENV || process.env.NODE_ENV,
    merchantSlug: merchant?.slug || '',
    merchantId: merchant?.id || '',
    userId: user?.id || '',
    userRole: user?.role || '',
    storeId: user?.store?.id || '',
    storeSlug: user?.store?.slug || ''
  })

  return (
    <SessionContext.Provider value={initialSessionState}>
      {!!process.env.REACT_APP_TEST_ENV && <DevInfoBanner />}
      {token && user && merchant ? (
        <SlerpClient config={{ apiKey: token, user: user }}>
          <GlobalQueryProvider>
            <GlobalContext>
              <HubspotChat />
              <AppRouter />
            </GlobalContext>
          </GlobalQueryProvider>
        </SlerpClient>
      ) : (
        <BrowserRouter>
          <Routes>
            <Route path='/sso' element={<SignIn />} />
            <Route path='/' element={<Login />} />
            <Route path='/forgot_password' element={<ForgotPasswordForm />} />
            <Route
              path='/merchants/reset_password/:token_id'
              element={<ResetPasswordForm />}
            />
            <Route
              path='/create-your-slerpspace'
              element={<OnboardingForm />}
            />
          </Routes>
        </BrowserRouter>
      )}
    </SessionContext.Provider>
  )
}

export default App
